module.exports = __webpack_public_path__ + "img/Visionly.cf7e3c9b.jpg";